import { addEventEntry } from '@printdeal/data-layer-manager';

export const dispatchDataLayerPlaceHolderExperiment = (experimentCode: number, variation: string) => {
  addEventEntry({
    eventCategory: 'algolia_placeholder_experiment',
    eventAction: `experiment_${experimentCode}`,
    eventNonInteraction: true,
    eventLabel: `Variation - ${variation}`,
  });
};
